<div [hidden]="type === 'hidden'"></div>
